import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import i18n from '../../utils/i18n';
import Text from '@adsk/bim360-matrix-react-text';
import Button from '@adsk/bim360-matrix-react-button';
import ModalConfirmation from '@adsk/bim360-matrix-react-modal-confirmation';
import {NotificationTypes, NotificationLevels} from '@adsk/bim360-matrix-react-notification-manager/es/helpers/consts';
import {templateType} from '../../constants/proptype-validation';
import {TEMPLATE_FIELD_NAMES, TEMPLATE_ISSUE_ATTRIBUTES_FIELD_NAMES} from '../../constants/issue-templates';

class TemplateDeleteModal extends PureComponent {
  constructor(...args) {
    super(...args);

    this.state = {
      isDeleting: false
    };
  }

  deleteTemplate = () => {
    this.setState({
      isDeleting: true
    });
    this.props.deleteTemplateAction(this.props.deleteTemplateId, {
      onSuccess: this.handleDeleteSuccess,
      onError: this.handleDeleteError
    });
  };

  handleDeleteSuccess = () => {
    const {template, showNotificationAction} = this.props;
    this.setState({
      isDeleting: false
    });
    this.closeModal();
    showNotificationAction({
      type: NotificationTypes.TOAST,
      level: NotificationLevels.SUCCESS,
      message: (
        <Text hasHTML>
          {i18n.t('templatesGrid.deleteModal.successMessage', {
            title: template[TEMPLATE_FIELD_NAMES.ISSUE_ATTRIBUTES][TEMPLATE_ISSUE_ATTRIBUTES_FIELD_NAMES.TITLE]
          })}
        </Text>
      )
    });
  };

  handleDeleteError = () => {
    this.setState({
      isDeleting: false
    });
    this.props.showNotificationAction({
      type: NotificationTypes.SNACKBAR,
      level: NotificationLevels.ERROR,
      message: i18n.t('templatesGrid.deleteModal.errorMessage')
    });
  };

  closeModal = () => {
    this.props.setDeleteTemplateIdAction(null);
  };

  render() {
    const {container, deleteTemplateId} = this.props;
    const {isDeleting} = this.state;
    return (
      <ModalConfirmation
        container={container}
        title={i18n.t('templatesGrid.deleteModal.title')}
        show={!!deleteTemplateId}
        onConfirm={this.deleteTemplate}
        disableModalExit={isDeleting}
        isOnConfirmInProgress={isDeleting}
        onExited={this.closeModal}
        message={i18n.t('templatesGrid.deleteModal.message')}
        confirmationButtonLabel={i18n.t('navigation.delete')}
        confirmationButtonLabelInProgress={i18n.t('navigation.deleting')}
        confirmationButtonStyleType={Button.StyleType.DANGER}
      />
    );
  }
}

TemplateDeleteModal.displayName = 'TemplateDeleteModal';

TemplateDeleteModal.propTypes = {
  container: PropTypes.object,
  deleteTemplateId: PropTypes.string,
  template: templateType,
  setDeleteTemplateIdAction: PropTypes.func.isRequired,
  deleteTemplateAction: PropTypes.func.isRequired,
  showNotificationAction: PropTypes.func.isRequired
};

export default TemplateDeleteModal;
